import TableRowAction from 'components/common/TableRowAction';
import React, { useContext, useState } from 'react';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import SelectStudentModal from '../school/SelectStudentModal';

import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import AuthContext from 'context/authContext';
import dayjs from 'dayjs';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import OrphanageForm from './OrphanageForm';
import useUpload from '../../../hooks/useUpload';
import { useCreateOrphanage } from 'hooks/useBeneficiaries';

function AddOrphanage() {
  const [showStudentAddModal, setShowStudentAddModal] = useState(false);
  const { organization, selectedBranchId } = useContext(AuthContext);
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();
  const { createOrphanageAsync, isCreating } = useCreateOrphanage();

  const schoolColumns = [
    {
      accessor: 'first_name',
      Header: 'Name',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'DOB',
      Header: 'Age',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { DOB } = rowData.row.original;
        return <>{dayjs(DOB).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender'
    },
    {
      accessor: 'created_at',
      Header: 'Registration',
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return <>{dayjs(created_at).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'inspiration',
      Header: 'Aspiration'
    },
    {
      accessor: 'id_',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <TableRowAction
            onCLickDelete={() => removeStudent(id)}
            isNotEdit
            subject={permissionsKeyMap.facilities.children.orphanage}
          />
        );
      }
    }
  ];
  const [listOfStudents, setListOfStudents] = useState([]);

  const removeStudent = id => {
    setListOfStudents(listOfStudents.filter(item => item.id !== id));
  };

  const submitStudent = value => {
    // Note: This functionality needs to be implemented when beneficiary selection is ready
    console.log('Selected beneficiary:', value);
  };

  const submitAddOrphanage = async data => {
    try {
      let documentsUrl = data.document;

      if (data.document && typeof data.document !== 'string') {
        documentsUrl = await upload(data.document);
      }

      // Destructure to exclude form field that needs to be renamed
      const { document, ...rest } = data;

      const orphanageData = {
        ...rest,
        documents: documentsUrl, // Orphanages table uses 'documents' (plural)
        organisation_id: organization.id
      };

      // Only add branch_id if it's not 'all'
      if (selectedBranchId && selectedBranchId !== 'all') {
        orphanageData.branch_id = selectedBranchId;
      }

      await createOrphanageAsync(orphanageData);
      navigate(-1);
    } catch (error) {
      console.error('Error creating orphanage:', error);
    }
  };
  return (
    <>
      <OrphanageForm
        onSubmit={submitAddOrphanage}
        loading={isCreating || uploadLoading}
      />
      <SelectStudentModal
        show={showStudentAddModal}
        onHide={() => setShowStudentAddModal(false)}
        onSubmit={submitStudent}
      />
      <Row className="mt-3">
        <Col md={12} xxl={12} className="h-md-100">
          {listOfStudents && (
            <CustomAdvanceTable
              data={listOfStudents}
              columns={schoolColumns}
              title="Orphans"
              addButtonLabel="Add Orphan"
              addButtonIcon="user"
              onClickAddNew={() => {
                setShowStudentAddModal(true);
              }}
              addNew
              subject={permissionsKeyMap.facilities.children.school}
              bulkActionsOptions
              handleBulkAction
              selection={true}
            />
          )}
        </Col>
      </Row>
    </>
  );
}

export default AddOrphanage;
